import { infoGraphKeys } from './info_graph_subscription';

function clearReceivedValues(parent) {
  for (const key of Object.keys(parent.settings ?? {})) delete parent.settings[key];
  for (const key of Object.keys(parent.infos ?? {})) {
    if (!infoGraphKeys.has(key)) delete parent.infos[key];
  }
  delete parent.multi_io_infos;
  delete parent.multi_io_counters;
  if (parent.skipped_values) {
    for (const key of Object.keys(parent.skipped_values)) delete parent.skipped_values[key];
  }
}

export function prepareControllerResync(controller) {
  if (!controller?.connection) return;
  // Notify the page's resync guard before settings subscribers so forms unmount
  // before they can render the cleared categories.
  Object.assign(controller.connection, {
    awaiting_values: true,
    request_values_full: false,
    requested_all: false,
    last_received: 0,
    info_graphs_received: false,
    info_graphs_received_at: 0,
    info_graphs_requested_at: 0
  });
  // Received state belongs to this connection. Keep the proxy objects, local
  // drafts, preferences and historical graph data when rebuilding from the server.
  clearReceivedValues(controller);
  for (const zone of Object.values(controller.zones ?? {})) clearReceivedValues(zone);
  for (const key of ['overwr_io', 'ext_readings', 'ahu_info', 'ahu_unit']) delete controller[key];
  if (controller.slaves) controller.slaves.splice(0);
}
